import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';

import User from './User';
import Adviser from './Adviser';

const reducers = (history) =>
  combineReducers({
    router: connectRouter(history),
    User,
    AdviserInviteReducer: Adviser,
  });

export default reducers;
